import ReactPaginate from "react-paginate";

const DEFAULT_PAGINATION_PROPS = {
  breakLabel: "...",
  nextLabel: "NEXT",
  pageRangeDisplayed: 5,
  previousLabel: "PREVIOUS",
  renderOnZeroPageCount: null,
};

const Pagination = ({ totalPages = 1, onPageChange = () => {}, currentPage = 1, ...rest }) => {
  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    onPageChange(newPage);
  };

  return (
    <ReactPaginate
      {...DEFAULT_PAGINATION_PROPS}
      forcePage={currentPage}
      pageCount={totalPages}
      onPageChange={handlePageClick}
      {...rest}
    />
  );
};

export default Pagination;
